import { economicIndicatorsRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const economicIndicatorsRoute: RouteObject = {
  path: economicIndicatorsRoutePaths.economicIndicators.path,
  async lazy() {
    const Page = await import('@/pages/economic-indicators');
    return { Component: Page.default };
  },
};
